<template>
  <div ref="$el" class="qr-code">
    <canvas ref="canvas"></canvas>
  </div>
</template>


<!-- <script>

export default {
  props: ["url", "debug", "margin"],
  components:{
  },
  watch:{
    url(){
       
        let fullUrl = this.url
        let size = Math.min(width.value, height.value)
        QRCode.toCanvas(canvas.value, fullUrl, {
        width: size,
        margin: props.margin || 1,
        color: {
            dark: "#000F",
            light: "#0000",
        },
        })
    }
  }
};
</script> -->

<script setup>
import QRCode from "qrcode"
import { ref, toRefs, watch } from "vue"
// import { useElementSize } from "@vueuse/core"

const canvas = ref()
// eslint-disable-next-line
const props = defineProps(["url", "debug", "margin"])
const { url } = toRefs(props)

const $el = ref()
// const { width, height } = useElementSize($el)
const width = ref(100)
const height = ref(100)
watch($el,()=>{
    console.log("el watched")
    width.value = $el.value.getBoundingClientRect().width
    height.value = $el.value.getBoundingClientRect().height
})
watch(
  [canvas, url],
  () => {
    if (!canvas.value || !url.value) return
    let fullUrl = url.value
    let size = Math.min(width.value, height.value)
    QRCode.toCanvas(canvas.value, fullUrl, {
      width: size,
      margin: props.margin || 1,
      color: {
        dark: "#000F",
        light: "#0000",
      },
    })
  },
  { immediate: true }
)
</script>

<style lang="stylus" scoped>
.qr-code
  align-items: center
  display: flex
  flex-direction: column
  justify-content: center
  aspect-ratio: 1 / 1
  background #fff 
</style>
